import { fromJS } from 'immutable';

export const visibleColumns = fromJS([
  'year',
  'month',
  'day',
  'tsunamiEventId',
  'earthquakeEventId',
  'moreInfo',
  'name',
  'location',
  'country',
  'latitude',
  'longitude',
  'elevation',
  'volcanoes',
  'morphology',
  'vei',
  'agent',
  'deaths',
  'deathsAmountOrder',
  'missing',
  'missingAmountOrder',
  'injuries',
  'injuriesAmountOrder',
  'damageMillionsDollars',
  'damageAmountOrder',
  'housesDestroyed',
  'housesDestroyedAmountOrder',
  'deathsTotal',
  'deathsAmountOrderTotal',
  'missingTotal',
  'missingAmountOrderTotal',
  'injuriesTotal',
  'injuriesAmountOrderTotal',
  'damageMillionsDollarsTotal',
  'damageAmountOrderTotal',
  'housesDestroyedTotal',
  'housesDestroyedAmountOrderTotal',
]);

export const sort = fromJS([
  { id: 'year', asc: true },
  { id: 'month', asc: true },
  { id: 'day', asc: true },
]);

export const minColumns = fromJS([
  'year',
  'month',
  'day',
  'tsunamiEventId',
  'moreInfo',
  'name',
  'vei',
]);
